
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/corporatiu/avis-legal/participacions-i-concursos/[slug]",
      function () {
        return require("private-next-pages/corporatiu/avis-legal/participacions-i-concursos/[slug]/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/corporatiu/avis-legal/participacions-i-concursos/[slug]"])
      });
    }
  